import React from "react";
import { Container } from "react-bootstrap";
import Github from "../About/Github";
import Techstack from "../About/Techstack";
import Toolstack from "../About/Toolstack";
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
AOS.refreshHard();

function Skill() {
    return (
        <Container fluid className="about-section" name="skill">
            <h1 className="project-heading">
                Tech Skills
            </h1>
            <Techstack />
            <br />

            <h1 className="project-heading">
                Tools
            </h1>
            <Toolstack />
            <br />
            <Github />
        </Container>
    );
}

export default Skill;
